module.exports = __webpack_public_path__ + "img/sy.63358df7.jpg";